export default __webpack_public_path__ + "images/loggedout/icons/facebook_icon-b6fd45f5bcd2d4710202f85cf757a9d3.png";